import React from 'react';
import './styles.scss';
import TitlePages from 'components/_base/TitlePages';
import FormDataUser from 'components/FormDataUser';
import FormPassword from 'components/FormPassword';

const ContentDadosUsuario = () => {
  return (
    <div className="wrapper-dados-usuario">
      <div className="panel">
        <TitlePages title="MEUS DADOS" />
        <hr />
        <div className="content-meus-dados">
          <div className="dados col-lg-10">
            <FormDataUser />
          </div>
          <div className=" senha col-lg-10">
            <FormPassword />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentDadosUsuario;
